
export class UpdateGSMPortModel {
    public id: string;
    public isActive: string;
    public prefixes: string [];
}
